const ensureDatalayer = () => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

const getStoredUserId = () => {
  return localStorage.getItem('userId');
}

const pushToDataLayer = (args) => {
  const dataLayer = ensureDatalayer();
  dataLayer.push(args);
}

// Initialize GA
export const initGA = () => {
  const storedUserId = getStoredUserId();
  if (storedUserId) {
    pushToDataLayer({
      event: 'user_id_set',
      user_id: storedUserId
    });
  }
};

// Set User ID
export const setUserId = (userId) => {
  // Push user_id to dataLayer for GTM
  pushToDataLayer({
    event: 'user_id_set',
    user_id: userId
  });
  
  // Store for persistence across page refreshes
  if (userId) {
    localStorage.setItem('userId', userId);
  } else {
    localStorage.removeItem('userId');
  }
};

// Track page views
export const pageView = (path) => {
  // Check for stored user ID
  const storedUserId = getStoredUserId();
  
  pushToDataLayer({
    event: 'page_view',
    page_location: window.location.origin + path,
    page_title: document.title,
    page_path: path,
    user_id: storedUserId || undefined
  });
};

// Track events
export const event = ({ action, category, label, value }) => {
  // Check for stored user ID
  const storedUserId = getStoredUserId();
  
  pushToDataLayer({
    event: action,
    event_category: category,
    event_label: label,
    value: value,
    user_id: storedUserId || undefined
  });
};

// Clear User ID on logout
export const clearUserId = () => {
  localStorage.removeItem('userId');
  
  // Push event to clear user ID in GTM
  pushToDataLayer({
    event: 'user_id_cleared',
    user_id: undefined
  });
};